export enum paymentLinkStatus {
  active = "active",
  deactivated = "deactivated",
}
